import type { LDContext } from 'launchdarkly-react-client-sdk';

export const LAUNCH_DARKLY_STATIC_CONTEXT_KEY = 'products-benefits-web';

// LSAW-4620: flags here are global toggles, not per-user targeting, and this app never identifies a user.
// Without a key the SDK mints a random anonymous key per browser, and each one is billed as a client-side MAU.
// Use one fixed, reused anonymous context instead - same approach as atlas-payment-methods-service#684.
export const launchDarklyContext: LDContext = {
  anonymous: true,
  key: LAUNCH_DARKLY_STATIC_CONTEXT_KEY,
  kind: 'user',
};
